import { HEADING_HEIGHT_DESKTOP, HEADING_HEIGHT_MOBILE } from 'omakase/Dialog/dialogCoreCssDefs';
import { Theme, css } from '@emotion/react';

export const heading = ({ breakpoints }: Theme) => css`
  background: #000;
  height: ${HEADING_HEIGHT_MOBILE}px;
  border-bottom: none;
  ${breakpoints.up('sm')} {
    height: ${HEADING_HEIGHT_DESKTOP}px;
  }
  & > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const backArrowIconButton = ({ breakpoints, spacing }: Theme) => css`
  margin-right: auto;
  ${breakpoints.up('sm')} {
    display: none;
  }
`;

export const closeIconButton = ({ breakpoints, spacing }: Theme) => css`
  display: none;
  margin-left: auto;
  ${breakpoints.up('sm')} {
    display: inline-flex;
  }
`;

export const dialogContent = ({ breakpoints, spacing }: Theme) => css`
  align-items: center;
  background: #000;
  display: flex;
  justify-content: center;
  overflow: hidden;
  padding: 0 ${spacing(1)}px ${HEADING_HEIGHT_MOBILE}px;

  & .slick-slider {
    width: 100%;
    height: 100%;
  }
  & .slick-list {
    height: 100%;
    margin: 0 -8px;
  }
  & .slick-track {
    display: flex;
    height: 100%;
  }
  & .slick-track .slick-slide {
    display: flex;
    height: auto;
    align-items: center;
    justify-content: center;
  }
  & .slick-slide > div {
    height: 100%;
    padding: 0 8px;
  }
  ${breakpoints.up('sm')} {
    padding: 0 ${spacing(2)}px ${HEADING_HEIGHT_MOBILE}px;
  }
`;

export const slideContainer = () => css`
  flex: 0 0 100%;
  height: 100%;
  position: relative;
  & > img {
    object-fit: contain;
    height: 100%;
    width: 100%;
  }
`;

export const previousIconButton = (theme: Theme) => css`
  position: absolute;
  top: 50%;
  left: 32px;
  transform: translateY(-50%);
  display: none;
  ${theme.breakpoints.up('sm')} {
    display: flex;
  }
`;

export const nextIconButton = (theme: Theme) => css`
  position: absolute;
  top: 50%;
  right: 32px;
  transform: translateY(-50%);
  display: none;
  ${theme.breakpoints.up('sm')} {
    display: flex;
  }
`;
